import apiClient from './api.service';

export interface WorkstationControlCenterQueryParams {
  workstation_id?: string;
  department?: string;
  customer_name?: string;
  project_name?: string;
  execution_scope?: string;
  operator_user_id?: string;
  date_from?: string;
  date_to?: string;
  period?: 'today' | 'week' | 'month';
  status?: string;
  search?: string;
}

const base = '/manufacturing/workstation-control-center';

export const workstationControlCenterService = {
  getSummary: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/summary`, { params }),
  getStatusBoard: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/status-board`, { params }),
  getCurrentWork: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/current-work`, { params }),
  getQueues: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/queues`, { params }),
  getCapacity: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/capacity`, { params }),
  getHours: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/hours`, { params }),
  getFabricationUnits: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/fabrication-units`, { params }),
  getMaterialDependencies: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/material-dependencies`, { params }),
  getInspectionDependencies: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/inspection-dependencies`, { params }),
  getOutsourceDependencies: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/outsource-dependencies`, { params }),
  getBottlenecks: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/bottlenecks`, { params }),
  getOperators: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/operators`, { params }),
  getMaintenance: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/maintenance`, { params }),
  getCapacityForecast: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/capacity-forecast`, { params }),
  getTimeline: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/timeline`, { params }),
  getAlerts: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/alerts`, { params }),
  getAnalytics: (params?: WorkstationControlCenterQueryParams) =>
    apiClient.get(`${base}/analytics`, { params }),
};

export default workstationControlCenterService;
